'use client';

import React, { useState, useEffect } from 'react';

import CommentsSection from '@/ui/containers/CommentsSection';
import request from '@/utils/queryData/rest/clientRequest';

// import styled from 'styled-components';

// import Comment from './Comment';
// import Icon from '@/ui/components/Icon';

// const Loading = styled.div`
//   text-align: center;

//   svg {
//     height: 100px;
//     width: 100px;
//   }
// `;

// const NoComments = styled.div`
//   text-align: center;
// `;

interface CommentsProps {
  postId: string | number;
  visible: boolean;
  initialComments?: WordpressComment[];
}

export default function Comments({ postId, visible, initialComments = [] }: CommentsProps) {
  const [comments, setComments] = useState<CommentsRestPayload>({
    data: initialComments,
    info: {} as RestInfoPayload,
  });

  useEffect(() => {
    if (visible) {
      const fetchData = async () => {
        new request('comments')
          .get({
            lng: 'en',
            parent: postId.toString(),
            status: 'approve',
            per_page: '20',
            page: '1',
          })
          .then(data => {
            // const unpackedData = data?.data;
            setComments(data);
          })
          .catch(error => {
            console.error('Comments: Error loading comments', error);
          });
      };

      fetchData();
    }
  }, [postId, visible]);

  return (
    <div>
      <CommentsSection comments={comments.data} commentsInfo={comments.info} postId={postId} />
      {/* {comments === null ? (
        <Loading>
          <Icon style="solid" name="spinner-third" spin />
        </Loading>
      ) : comments.length > 0 ? (
        comments.map(comment => <Comment {...comment} key={comment.id} />)
      ) : (
        <NoComments>No comments</NoComments>
      )} */}
    </div>
  );
}
